"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeValues = exports.isRTL = exports.isEqualContent = exports.elx = exports.createPips = exports.clamp = void 0;

const sanitizeValues = (values, fallback) => {
  values = Array.isArray(values) ? values : [values];
  return values.map((v, i) => Number.isNaN(Number(v)) ? fallback[i] : Number(v));
};

exports.sanitizeValues = sanitizeValues;

const isEqualContent = (array1, array2) => {
  let equal = array1.length === array2.length;

  for (let i = 0; equal && i < array2.length; i++) equal = array1[i] === array2[i];

  return equal;
};

exports.isEqualContent = isEqualContent;

const elx = function () {
  for (var _len = arguments.length, listeners = new Array(_len), _key = 0; _key < _len; _key++) {
    listeners[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return listeners.map(listener => typeof listener === 'function' && listener(...args));
  };
};

exports.elx = elx;

const isRTL = () => !!document.querySelector('[dir="rtl"]');

exports.isRTL = isRTL;

const createPips = (step, marks, disabled, range, maxMarks) => {
  let pips;

  if (marks && !disabled) {
    const count = (range.max - range.min) / step;
    let density = 100 / Math.min(maxMarks, count);
    pips = {
      mode: 'range',
      density
    };
  }

  return pips;
};

exports.createPips = createPips;

const clamp = (num, min, max) => num > max ? max : num < min ? min : num;

exports.clamp = clamp;